module.exports = __webpack_public_path__ + "img/f4.2971ac19.png";